module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-white.d2db2c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-white.svg
// module id = 0gBk
// module chunks = 82